import React from 'react';

const Chip = ({ label, value }: { label: string; value: string }) => (
  <span>
    {label ? <span className="label">{label}</span> : ''} {value}
  </span>
);

export default Chip;
